import ikson from './ikson.js';

var helper = {

    init: function () {
    },

    headerScroll: function (elem, class_name, number) {
        var win = $(window);
        var header = $(elem);

        if (win.scrollTop() >= number) {
            header.addClass(class_name);
        } else {
            header.removeClass(class_name);
        }
        win.on('scroll', function () {
            if (win.scrollTop() > number) {
                header.addClass(class_name);
            } else {
                header.removeClass(class_name);
            }
        });
    },

    open: function (trigger, target, toAdd, secondTrigger, customElement) {
        $(document).mouseup(function (e) {
            if ($(e.target).is(trigger) || $(e.target).is(secondTrigger)) {
                if ($(target).hasClass(toAdd)) {
                    $(target).removeClass(toAdd)
                    if (customElement) {
                        $(customElement).removeClass('opened')
                    }
                } else {
                    $(target).addClass(toAdd);
                    if (customElement) {
                        $(customElement).addClass('opened')
                    }
                }
            } else {
                var container = $(target);
                if (!container.is(e.target) && (container.has(e.target).length === 0)) {
                    container.removeClass('opened');
                    if (customElement) {
                        $(customElement).removeClass('opened')
                    }
                }
            }
        });
    },

    openLogged: function (trigger, target, toAdd, secondTrigger, customElement) {
        $(document).mouseup(function (e) {
            if ($(e.target).is(trigger) || $(e.target).is(secondTrigger)) {
                if ($(target).hasClass(toAdd)) {
                    $(target).removeClass(toAdd)
                    if (customElement) {
                        $(customElement).removeClass('open')
                    }
                } else {
                    $(target).addClass(toAdd);
                    if (customElement) {
                        $(customElement).addClass('open')
                    }
                }
            } else {
                var container = $(target);
                if (!container.is(e.target) && (container.has(e.target).length === 0)) {
                    container.removeClass('open');
                    if (customElement) {
                        $(customElement).removeClass('open')
                    }
                }
            }
        });
    },

    openDownloadPanel: function (trigger, target, toAdd, secondTrigger, customElement) {
        $(document).mouseup(function (e) {
            if ($(e.target).is(trigger) || $(e.target).is(secondTrigger)) {
                if ($(target).hasClass(toAdd)) {
                    $(target).removeClass(toAdd)
                    if (customElement) {
                        $(customElement).removeClass('open')
                    }
                } else {
                    $(target).addClass(toAdd);
                    if (customElement) {
                        $(customElement).addClass('open')
                        ikson.loadDownload($(e.target).attr('data-trackid'));
                    }
                }
            } else {
                var container = $(target);
                if (!container.is(e.target) && (container.has(e.target).length === 0)) {
                    container.removeClass('open');
                    if (customElement) {
                        $(customElement).removeClass('open')
                    }
                }
            }
        });
    },

    openLoginPanel: function (trigger, target, toAdd, secondTrigger, customElement) {
        $(document).mouseup(function (e) {
            if ($(e.target).is(trigger) || $(e.target).is(secondTrigger)) {
                if ($(target).hasClass(toAdd)) {
                    $(target).removeClass(toAdd)
                    if (customElement) {
                        $(customElement).removeClass('open')
                    }
                } else {
                    $(target).addClass(toAdd);
                    if (customElement) {
                        $(customElement).addClass('open')
                    }
                }
            } else {
                var container = $(target);
                if (!container.is(e.target) && (container.has(e.target).length === 0)) {
                    container.removeClass('open');
                    if (customElement) {
                        $(customElement).removeClass('open')
                    }
                }
            }
        });
    },
    openSignupPanel: function (trigger, target, toAdd, secondTrigger, customElement) {
        $(document).mouseup(function (e) {
            if ($(e.target).is(trigger) || $(e.target).is(secondTrigger)) {
                if ($(target).hasClass(toAdd)) {
                    $(target).removeClass(toAdd)
                    if (customElement) {
                        $(customElement).removeClass('open')
                    }
                } else {
                    $(target).addClass(toAdd);
                    if (customElement) {
                        $(customElement).addClass('open')
                    }
                }
            } else {
                var container = $(target);
                if (!container.is(e.target) && (container.has(e.target).length === 0)) {
                    container.removeClass('open');
                    if (customElement) {
                        $(customElement).removeClass('open')
                    }
                }
            }
        });
    },
    openSignupDownload: function (trigger, target, toAdd, secondTrigger, customElement) {
        $(document).mouseup(function (e) {
            if ($(e.target).is(trigger) || $(e.target).is(secondTrigger)) {
                if ($(target).hasClass(toAdd)) {
                    $(target).removeClass(toAdd)
                    if (customElement) {
                        $(customElement).removeClass('open')
                    }
                } else {
                    $(target).addClass(toAdd);
                    if (customElement) {
                        $(customElement).addClass('open')
                    }
                }
            } else {
                var container = $(target);
                if (!container.is(e.target) && (container.has(e.target).length === 0)) {
                    container.removeClass('open');
                    if (customElement) {
                        $(customElement).removeClass('open')
                    }
                }
            }
        });
    },

    openContact: function (trigger, target, toAdd, secondTrigger, customElement) {
        $(document).mouseup(function (e) {
            if (e.target.id == 'main-play-icon') {
                return false;
            }
            if ($(e.target).is(trigger) || $(e.target).is(secondTrigger)) {
                if ($(target).hasClass(toAdd)) {
                    $(target).removeClass(toAdd)
                    if (customElement) {
                        $(customElement).removeClass('open')
                    }
                } else {
                    $(target).addClass(toAdd);
                    if (customElement) {
                        $(customElement).addClass('open')
                    }
                }
            } else {
                var container = $(target);
                if (!container.is(e.target) && (container.has(e.target).length === 0)) {
                    container.removeClass('open');
                    if (customElement) {
                        $(customElement).removeClass('open')
                    }
                }
            }
        });
    },
    openPanelMessage: function (trigger, target, toAdd, secondTrigger, customElement) {
        $(document).mouseup(function (e) {
            if ($(e.target).is(trigger) || $(e.target).is(secondTrigger)) {
                if ($(target).hasClass(toAdd)) {
                    $(target).removeClass(toAdd)
                    if (customElement) {
                        $(customElement).removeClass('open')
                    }
                } else {
                    $(target).addClass(toAdd);
                    if (customElement) {
                        $(customElement).addClass('open')
                    }
                }
            } else {
                var container = $(target);
                if (!container.is(e.target) && (container.has(e.target).length === 0)) {
                    container.removeClass('open');
                    if (customElement) {
                        $(customElement).removeClass('open')
                    }
                }
            }
        });
    },
    openTFAPanel: function (trigger, target, toAdd, secondTrigger, customElement) {
        $(document).mouseup(function (e) {
            if ($(e.target).is(trigger) || $(e.target).is(secondTrigger)) {
                if ($(target).hasClass(toAdd)) {
                    $(target).removeClass(toAdd)
                    if (customElement) {
                        $(customElement).removeClass('open')
                    }
                } else {
                    $(target).addClass(toAdd);
                    if (customElement) {
                        $(customElement).addClass('open')
                    }
                }
            } else {
                var container = $(target);
                if (!container.is(e.target) && (container.has(e.target).length === 0)) {
                    container.removeClass('open');
                    if (customElement) {
                        $(customElement).removeClass('open')
                    }
                }
            }
        });
    },
};

export default helper;
